import { fetchShopTags, submitShopTags } from '@/services/api';
import router from 'umi/router';
import { Modal } from 'antd';
import cloneDeep from 'lodash/cloneDeep'
import { shopTagsStateSync } from '@/utils/logicUtils';

const modalError = async({ code, msg = '', data = {} }) => {
  Modal.error({
    title: '提交失败',
    content: msg,
  });
}
const DEFAULT_STATE = {
  searchTagKey: '',
  shopTagsBackup: {},
  shopTags: {},// 门店标签信息
  searchedShopTags: {},// 搜索的标签信息
  defaultSelectedTags: {},// 保存初始选中的标签集合
  selectedTags: {},// 选中的标签集合
  deletedSystemTags: {},// 删除的系统标签集合
};

// 数据兼容性处理
const dataProcess = (data) => {
  !data.commonList && (data.commonList = []);
  !data.systemGroup && (data.systemGroup = {});
  !data.systemGroup.writeList && (data.systemGroup.writeList = []);
  !data.systemGroup.readList && (data.systemGroup.readList = []);
  !data.systemGroup.unSelectList && (data.systemGroup.unSelectList = []);
  if (data.systemGroup.unSelectList) {
    data.systemGroup.unSelectList.map(item => item.disabled = true);
  }
}

export default {
  namespace: 'shopTag',

  state: {
    ...DEFAULT_STATE,
  },

  effects: {
    *fetchShopTags({ payload }, { call, put, select }) {
      // 后端接口设计特别不合理，但是B端已经用了， 没办法改了。。。
      // 不合理的接口设计导致前端组件逻辑复用困难，代码量也变多了
      const shopTagsRes = yield call(fetchShopTags, payload);
      dataProcess(shopTagsRes);
      // 搜索后的结果
      if (payload.keyword) {
        // 需要将用户修改的数据同步到搜索结果
        const { shopTags } = yield select(state => state.shopTag);
        shopTagsStateSync(shopTags, shopTagsRes);
        yield put({
          type: 'setFieldValue',
          payload: {
            searchedShopTags: shopTagsRes,
          },
        });
      } else {// 门店标签
        yield put({
          type: 'setFieldValue',
          payload: {
            shopTags: shopTagsRes,
            shopTagsBackup: cloneDeep(shopTagsRes),
          },
        });
      }
    },
    *submitShopTags({ payload }, { call, put }) {
      const response = yield call(submitShopTags, payload);
      if (response && response.code === 200) {
        yield put({
          type: 'clearShopTags',
        });
        yield put({
          type: 'poi/clearEditPoiInfo',
        });
        yield put({
          type: 'success/setSuccessField',
        });
        router.push('/errors/result/success');
      } else if(response) {
        const { code, msg = '错误', data } = response;
        return modalError({ code, msg, data });
      }
    },
  },

  reducers: {
    setFieldValue(state, action) {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    },
    clearShopTags(state, action) {
      return {
        ...DEFAULT_STATE,
      };
    }
  },
};
